import React, { useEffect, useState, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalStorageItem, numberWheelChange } from "../../../../../utils";
import ErrorLabel from "../../../../../component/error_label";
import {
  actionClaimAdd,
  resetClaimAdd,
  actionClaimEdit,
  resetClaimEdit,
} from "./../store/index";
import $ from "jquery";
import { downloadFile } from "../../../../../utils";
import { useDropzone } from "react-dropzone";
import { actionPolicyList, resetPolicyList } from "../../list/store";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import Select from "react-select";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../../common/app_constant";
import Swal from "sweetalert2";
import {
  actionDownload,
  resetDownloadPolicyResponse,
} from "../../dashboard/store";

const ClaimForm = (props) => {
  const { ClaimAdd, ClaimEdit } = useSelector((state) => ({
    ...state.formStore,
  }));
  const { PolicyList } = useSelector((state) => ({
    ...state.listStore,
  }));
  const { downloadPolicy } = useSelector((state) => ({
    ...state.dashboardStore,
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [policyDropdown, setPolicyDropdown] = useState([]);
  const [role, setRole] = useState();
  const [selectedPolicyId, setSelectedPolicyId] = useState([]);
  const [policyStartDate, setPolicyStartDate] = useState();
  const [policyData, setPolicyData] = useState([]);
  const [policyDetails, setPolicyDetails] = useState({});
  const [attachment, setAttachment] = useState([]);
  const [attachment2, setAttachment2] = useState([]);
  const [document, setDocument] = useState([]);
  const [loading, setLoading] = useState(false)
  const location = useLocation();
  const initialData = location.state?.data;
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
  } = useForm({
    defaultValues: initialData,
  });

  const claimStatus = watch("status");
  const lossAmount = watch("loss_amount");

  useEffect(() => {
    dispatch(actionPolicyList());
    setRole(getLocalStorageItem("next"));
  }, []);

  useEffect(() => {
    if (initialData) {
      Object.keys(initialData).forEach((key) => {
        setValue(key, initialData[key]);
      });
      setValue("product_details", initialData?.policy_detail?.policy_type);
      setSelectedPolicyId(initialData?.policy_id);
      setDocument(initialData?.claimDocument || []);
      setValue('date_of_loss', initialData.date_of_loss !== null ? moment(initialData.date_of_loss).format("DD-MM-YYYY") : '');
      setValue('insured_intimation_date', initialData.insured_intimation_date !== null ? moment(initialData.insured_intimation_date).format("DD-MM-YYYY") : '');
      setValue('final_intimation_date', initialData.final_intimation_date !== null ? moment(initialData.final_intimation_date).format("DD-MM-YYYY") : '');
      setValue('insurer_intimation_date', initialData.insurer_intimation_date !== null ? moment(initialData.insurer_intimation_date).format("DD-MM-YYYY") : '');
      setValue('claim_closed_date', initialData.claim_closed_date !== null ? moment(initialData.claim_closed_date).format("DD-MM-YYYY") : '');
      setValue('follow_up_date', initialData.follow_up_date !== null ? moment(initialData.follow_up_date).format("DD-MM-YYYY") : '');
    }
  }, [initialData]);

  useEffect(() => {
    if (PolicyList) {
      dispatch(resetPolicyList());
      if (PolicyList.status) {
        setPolicyData(PolicyList.data.policyList);
        const PolicyDropdown = PolicyList?.data?.policyList?.map(
          (item, index) => ({
            label: item.policy_no,
            value: item.id,
          })
        );
        setPolicyDropdown(PolicyDropdown);
      }
    }
  }, [PolicyList]);

  useEffect(() => {
    if (downloadPolicy !== null) {
      dispatch(resetDownloadPolicyResponse());
      if (downloadPolicy.status === true) {
        if (downloadPolicy.status === true && Array.isArray(downloadPolicy.data.urls)) {
          downloadPolicy.data.urls.forEach(item => {
            if (item.url) {
              window.open(item.url, '_blank');
            }
          });
        }
      } else {
        switch (downloadPolicy.status_code) {
          case 400:
            toast.error(downloadPolicy.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [downloadPolicy]);

  useEffect(() => {
    if (selectedPolicyId) {
      let idPolicy = policyData.find((item) => item.id === selectedPolicyId);
      if (idPolicy) {
        setPolicyDetails(idPolicy);
        console.log(idPolicy);
      }
    }
  }, [selectedPolicyId]);

  useEffect(() => {
    if (initialData != null && initialData?.policy_id != null) {
      setValue("policy_number", initialData?.policy_id);
    }
  }, [policyDropdown])

  useEffect(() => {
    if (lossAmount != null) {
      setValue("outstanding", lossAmount);
    }
  }, [lossAmount])

  useEffect(() => {
    Object.keys(policyDetails).forEach((key) => {
      setValue(key, policyDetails[key]);
      setValue("product_details", policyDetails?.policy_type);
      setValue("contact_person_name", policyDetails?.userDetails?.full_name);
      setValue(
        "contact_person_mobile_number",
        policyDetails?.userDetails?.mobile
      );
      setPolicyStartDate(
        moment(policyDetails?.policy_start_date).format("DD-MM-YYYY")
      );
    });
  }, [policyDetails]);

  useEffect(() => {
    if (ClaimAdd) {
      dispatch(resetClaimAdd());
      $("#add_edit_claim").prop("disabled", false);
      if (ClaimAdd.status === true) {
        setLoading(false)
        toast.success(ClaimAdd.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        setLoading(false)
        toast.error(ClaimAdd?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [ClaimAdd]);

  useEffect(() => {
    if (ClaimEdit) {
      dispatch(resetClaimEdit());
      $("#add_edit_claim").prop("disabled", false);
      if (ClaimEdit.status === true) {
        setLoading(false)
        toast.success(ClaimEdit.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        setLoading(false)
        toast.error(ClaimEdit?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [ClaimEdit]);

  const onDrop = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment.length < 100) {
      setAttachment([...attachment, ...acceptedFiles]);
    } else {
    }
  });

  const onDrop2 = useCallback((acceptedFiles) => {
    $("#document-required").addClass("d-none");
    if (attachment2.length < 5) {
      setAttachment2([...attachment2, ...acceptedFiles]);
    } else {
    }
  });

  const {
    getRootProps: getRootProps2,
    getInputProps: getInputProps2,
    fileRejections: fileRejections2,
  } = useDropzone({
    accept: {
      accept: [
        ".pdf",
        ".doc",
        ".docx",
        ".jpeg",
        ".jpg",
        ".png",
        ".xls",
        ".xlsx"
      ]
    },
    multiple: true,
    maxFiles: 3,
    maxSize: 5 * 1024 * 1024, // 5 MB file size limit
    onDrop: onDrop2,
  });

  const fileRejectionItems2 = fileRejections2.map(({ file, errors }) => (
    <div key={file.path} className="text-danger mt-2 small">
      <strong>{file.name}</strong> - {(file.size / 1024 / 1024).toFixed(2)} MB
      {errors.map((e, index) => (
        <div key={index}> {e.message}</div>
      ))}
    </div>
  ));

  const removeFile = (file) => () => {
    const newFiles = [...attachment];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment(newFiles);
  };

  const removeFile2 = (file) => () => {
    const newFiles = [...attachment2];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment2(newFiles);
  };
  const removeAll2 = () => {
    setAttachment2([]);
  };
  const removeAll = () => {
    setAttachment([]);
  };
  const thumbs2 = attachment2?.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile2(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  const onSubmit = (data) => {

    data.policy_id = Number(selectedPolicyId); // Ensure it's a number

    let files = [];

    if (attachment2.length > 0) {
      attachment2.forEach((objImage, index) => {
        files.push({
          name: "file",
          value: objImage,
        });
      });
    }
    Object.keys(data).forEach(key => {
      if (data[key] == undefined || data[key] == null || !data[key]) {
        delete data[key];
      }
    });
    const dateFields = [
      "date_of_loss",
      "insured_intimation_date",
      "final_intimation_date",
      "insurer_intimation_date",
      "claim_closed_date",
      "follow_up_date",
    ];
    dateFields.forEach((fieldName) => {
      if (data[fieldName]) {
        data[fieldName] = moment(data[fieldName], "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
      }
    });
    var input = { ...data };
    if (initialData) {
      $("#add-edit-claim-loader").removeClass("hidden");
      $("#add_edit_claim").prop("disabled", true);
      dispatch(actionClaimEdit({ input, files }));
      setLoading(true)
    } else {
      if (role == "copsdashboard") {
        $("#add-edit-claim-loader").removeClass("hidden");
        $("#add_edit_claim").prop("disabled", true);
        dispatch(
          actionClaimAdd({
            dynamic_url: "admin/claim/add",
            input, files
          })
        );
        setLoading(true)
      } else if (role == 'employerdashboard') {
        $("#add-edit-claim-loader").removeClass("hidden");
        $("#add_edit_claim").prop("disabled", true);
        dispatch(
          actionClaimAdd({
            dynamic_url: "employer/claim-add",
            input, files
          })
        );
        setLoading(true)
      }
      // dispatch(actionClaimAdd({ input, files }));
    }
  };

  return (
    <>
      <section className="pb-5">
        <div className="card mb-5 mt-6">
          <div className="card-header bg-primary  d-flex justify-content-between">
            Claim {initialData ? "Edit" : "Add"}
            <h6
              className="text-white mb-0 cursor-pointer"
              onClick={(event) => {
                event.preventDefault();
                navigate(-1);
              }}
            >
              {" "}
              Back
            </h6>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                <form
                  noValidate
                  autoComplete="Off"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="form-body">
                    <div className="row mb-3">
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label htmlFor="policy_number" className="label-control">
                            Policy Number <span className="text-danger">*</span>
                          </label>

                          <Controller
                            name="policy_number"
                            control={control}
                            defaultValue=""
                            rules={{ required: "This is required." }}
                            render={({ field }) => (
                              <select
                                className="form-control"
                                {...field}
                                value={field.value || ""}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);

                                  const selected = policyDropdown.find(
                                    (p) => String(p.value) === value
                                  );

                                  if (selected) {
                                    setSelectedPolicyId(selected.value);
                                  }
                                }}
                              >
                                <option value="">Select</option>
                                {policyDropdown.map((policy) => (
                                  <option
                                    key={policy.value}
                                    value={String(policy.value)}
                                  >
                                    {policy.label}
                                  </option>
                                ))}
                              </select>
                            )}
                          />

                          {errors.policy_number && (
                            <ErrorLabel message={errors.policy_number.message} />
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Product Details
                          </label>
                          <input
                            className="form-control"
                            id="product_details"
                            name="product_details"
                            readOnly
                            {...register("product_details")}
                          />
                        </div>
                      </div>
                      {policyStartDate && (
                        <div className="col-12 col-md-3 mb-3">
                          <div class="form-group has-search">
                            <label for="date_of_loss" class="form-label">
                              Date of Loss<span class="text-danger">*</span>
                            </label>
                            <span class="fa fa-calendar form-control-feedback"></span>
                            <Controller
                              name="date_of_loss"
                              control={control}
                              render={({ field }) => (
                                <Flatpickr
                                  {...field}
                                  onChange={(value) => {
                                    var date = new Date(value).toISOString();
                                    setValue(
                                      "date_of_loss",
                                      moment(date).format("DD-MM-YYYY")
                                    );
                                  }}
                                  id="disabled-picker"
                                  className="form-control"
                                  options={{
                                    dateFormat: "d-m-Y",
                                    minDate: policyStartDate, // Convert policyStartDate to a Date object if it's a string
                                    maxDate: new Date(), // Set the maximum date to the current date
                                    enableTime: false,
                                  }}
                                />
                              )}
                              rules={{
                                required: "This is required.",
                              }}
                            />
                            {errors.date_of_loss && (
                              <ErrorLabel
                                message={errors.date_of_loss?.message}
                              />
                            )}
                          </div>
                        </div>
                      )}

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Claim Type<span className="danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            id="claim_type"
                            name="claim_type"
                            placeholder="Select.."
                            {...register("claim_type", {
                              required: "This is required.",
                            })}
                          >
                            <option value="">Claim Type</option>

                            <option value="OD Damages">OD Damages</option>
                            <option value="Third Party Claim">
                              Third Party Claim
                            </option>
                            <option value="Theft Claim">Theft Claim</option>
                            <option value="Other">Other</option>
                          </select>
                          {errors.claim_type && (
                            <ErrorLabel message={errors.claim_type?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Nature Of Claim&nbsp;
                            <span className="danger">*</span>
                          </label>
                          <select
                            id="nature_of_claim"
                            name="nature_of_claim"
                            className="form-control"
                            {...register("nature_of_claim", {
                              required: "This is required.",
                            })}
                          >
                            <option value="">Nature Of Claim</option>
                            <option value="Accident">Accident</option>
                            <option value="AOG Peril">AOG Peril</option>
                            <option value="Others">Others</option>
                          </select>
                          {errors.nature_of_claim && (
                            <ErrorLabel
                              message={errors.nature_of_claim?.message}
                            />
                          )}
                        </div>
                      </div>

                      {/* claim list as per excel sheet */}

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Loss Amount
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="loss_amount"
                            name="loss_amount"
                            {...register("loss_amount", {
                              // required: "This is required.",
                            })}
                          />
                          {errors.loss_amount && (
                            <ErrorLabel message={errors.loss_amount?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Loss Details
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="loss_details"
                            name="loss_details"
                            {...register("loss_details", {
                              required: "This is required.",
                            })}
                          />
                          {errors.loss_details && (
                            <ErrorLabel
                              message={errors.loss_details?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Loss Location
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="loss_location"
                            name="loss_location"
                            {...register("loss_location", {})}
                          />
                          {errors.loss_location && (
                            <ErrorLabel
                              message={errors.loss_location?.message}
                            />
                          )}
                        </div>
                      </div>
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            amount <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            onFocus={numberWheelChange}
                            id="amount"
                            name="amount"
                            placeholder="Enter"
                            {...register("amount", {
                              required: "This is required.",
                            })}
                          />
                          {errors.amount && (
                            <ErrorLabel message={errors.amount?.message} />
                          )}
                        </div>
                      </div> */}
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Surveyor Name&nbsp;
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="surveyor_name"
                            name="surveyor_name"
                            {...register("surveyor_name", {})}
                          />
                          {errors.surveyor_name && (
                            <ErrorLabel
                              message={errors.surveyor_name?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Status <span className="danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            id="status"
                            name="status"
                            placeholder="Select.."
                            {...register("status", {
                              required: "This is required.",
                            })}
                          >
                            <option value="In Progress">In Progress</option>
                            <option value="Withdrawn">Withdrawn</option>
                            <option value="Rejected">Rejected</option>
                            <option value="Within Excess">Within Excess</option>
                            <option value="Closed">Closed </option>
                            <option value="Settled">Settled</option>
                            <option value="Partially Settled">
                              Partially Settled
                            </option>
                            <option value="Partially Approved">
                              Partially Approved
                            </option>
                            <option value="Approved">Approved </option>
                            <option value="Surveyor Appointed">
                              Surveyor Appointed
                            </option>
                            <option value="Discrepancy">Discrepancy </option>
                            <option value="Pending Documents">
                              Pending Documents
                            </option>
                            {/* <option value="No Response">No response </option> */}
                            <option value="Others">Others </option>
                          </select>
                          {errors.status && (
                            <ErrorLabel message={errors.status?.message} />
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Settlement Amount
                          </label>
                          <input
                            className="form-control"
                            type="number"
                            onFocus={numberWheelChange}
                            id="settlement_amount"
                            name="settlement_amount"
                            placeholder="Enter"
                            {...register("settlement_amount", {
                              required:
                                claimStatus === "Settled" ||
                                  claimStatus === "Partially Settled"
                                  ? "This is required."
                                  : false,
                            })}
                          />
                          {errors.settlement_amount && (
                            <ErrorLabel
                              message={errors.settlement_amount?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Outstanding
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            defaultValue={lossAmount}
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="outstanding"
                            name="outstanding"
                            {...register("outstanding", {
                              required: "This is Required",
                            })}
                          />
                          {errors.outstanding && (
                            <ErrorLabel message={errors.outstanding?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Excess Amount
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="excess_amount"
                            name="excess_amount"
                            {...register("excess_amount", {})}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Loss State
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="loss_state"
                            name="loss_state"
                            {...register("loss_state", {
                              pattern: {
                                value: /^[a-zA-Z0-9 ,/,\\,_,.,#,-]*$/,
                                message: "Enter Valid State",
                              },
                            })}
                          />
                          {errors.loss_state && (
                            <ErrorLabel message={errors.loss_state?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            asset Detail
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="asset_detail"
                            name="asset_detail"
                            {...register("asset_detail", {
                              pattern: {
                                value: /^[a-zA-Z0-9 ,/,\\,_,.,#,-]*$/,
                                message: "Enter Valid Details",
                              },
                            })}
                          />
                          {errors.asset_detail && (
                            <ErrorLabel
                              message={errors.asset_detail?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Contact Person Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="contact_person_name"
                            name="contact_person_name"
                            {...register("contact_person_name", {
                              required: "This is Required",
                              pattern: {
                                value: /^[a-zA-Z0-9\s.]+$/,
                                message: "Enter Valid Name",
                              },
                            })}
                          />
                          {errors.contact_person_name && (
                            <ErrorLabel
                              message={errors.contact_person_name?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Contact Person Mobile Number
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="contact_person_mobile_number"
                            name="contact_person_mobile_number"
                            {...register("contact_person_mobile_number", {
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message:
                                  "Please enter a valid 10-digit mobile number.",
                              },
                            })}
                          />
                          {errors.contact_person_mobile_number && (
                            <ErrorLabel
                              message={
                                errors.contact_person_mobile_number?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Alternate Contact Person Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="alternate_contact_person_name"
                            name="alternate_contact_person_name"
                            {...register("alternate_contact_person_name", {
                              pattern: {
                                value: /^[a-zA-Z0-9\s.]+$/,
                                message: "Enter Valid Name",
                              },
                            })}
                          />
                          {errors.alternate_contact_person_name && (
                            <ErrorLabel
                              message={
                                errors.alternate_contact_person_name?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Alternate Contact Person Number
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="alternate_contact_person_mobile_number"
                            name="alternate_contact_person_mobile_number"
                            {...register(
                              "alternate_contact_person_mobile_number",
                              {
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message:
                                    "Please enter a valid 10-digit mobile number.",
                                },
                              }
                            )}
                          />
                          {errors.alternate_contact_person_mobile_number && (
                            <ErrorLabel
                              message={
                                errors.alternate_contact_person_mobile_number
                                  ?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Alternate Contact Person Email
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="alternate_contact_person_email"
                            name="alternate_contact_person_email"
                            {...register("alternate_contact_person_email", {
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Regex pattern for email validation
                                message: "Please enter a valid email address.",
                              },
                            })}
                          />
                          {errors.alternate_contact_person_email && (
                            <ErrorLabel
                              message={
                                errors.alternate_contact_person_email?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div class="form-group has-search">
                          <label for="final_intimation_date" class="form-label">
                            Final Intimation Date{" "}
                            <span className="danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="final_intimation_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "final_intimation_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  // minDate: moment(policyStartDate).format("DD-MM-YYYY"),// Set the minimum date to the policy start date
                                  // maxDate: new Date(), // Set the maximum date to the current date
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required: "This is required.",
                            }}
                          />
                          {errors.final_intimation_date && (
                            <ErrorLabel
                              message={errors.final_intimation_date?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insured Intimation Mode
                            <span className="danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            id="insured_intimation_mode"
                            name="insured_intimation_mode"
                            placeholder="Select.."
                            {...register("insured_intimation_mode", {
                              required: "This is required.",
                            })}
                          >
                            <option value="Portal">Portal</option>
                            <option value="Email">Email</option>
                            <option value="Verbal">Verbal</option>
                            <option value="Admin">Admin</option>
                          </select>
                          {errors.insured_intimation_mode && (
                            <ErrorLabel
                              message={errors.insured_intimation_mode?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group has-search">
                          <label
                            for="insured_intimation_date"
                            class="form-label"
                          >
                            Insured Intimation Date
                            <span className="danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="insured_intimation_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "insured_intimation_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  // minDate: moment(policyStartDate).format("DD-MM-YYYY"),// Set the minimum date to the policy start date
                                  // maxDate: new Date(), // Set the maximum date to the current date
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required:
                                claimStatus === "In Progress" ||
                                  claimStatus === "Within Excess" ||
                                  claimStatus === "Withdrawn"
                                  ? false
                                  : "This is required.",
                            }}
                          />
                          {errors.insured_intimation_date && (
                            <ErrorLabel
                              message={errors.insured_intimation_date?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Intimation Mode
                            <span className="danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            id="insurer_intimation_mode"
                            name="insurer_intimation_mode"
                            placeholder="Select.."
                            {...register("insurer_intimation_mode", {
                              required:
                                claimStatus === "In Progress" ||
                                  claimStatus === "Within Excess" ||
                                  claimStatus === "Withdrawn"
                                  ? false
                                  : "This is required.",
                            })}
                          >
                            <option value="">Insurer Intimation Mode</option>
                            <option value="Portal">Portal</option>
                            <option value="Email">Email</option>
                            <option value="SMS">SMS</option>
                            <option value="Verbal">Verbal</option>
                            <option value="Direct Intimation">
                              Direct Intimation
                            </option>
                            <option value="Others">Others</option>
                          </select>
                          {errors.insurer_intimation_mode && (
                            <ErrorLabel
                              message={errors.insurer_intimation_mode?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div class="form-group has-search">
                          <label
                            for="insurer_intimation_date"
                            class="form-label"
                          >
                            Insurer Intimation Date
                            <span className="danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="insurer_intimation_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "insurer_intimation_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",
                                  // minDate: moment(policyStartDate).format("DD-MM-YYYY"),// Set the minimum date to the policy start date
                                  // maxDate: new Date(), // Set the maximum date to the current date
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required:
                                claimStatus === "In Progress" ||
                                  claimStatus === "Within Excess" ||
                                  claimStatus === "Withdrawn"
                                  ? false
                                  : "This is required.",
                            }}
                          />
                          {errors.insurer_intimation_date && (
                            <ErrorLabel
                              message={errors.insurer_intimation_date?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Claim No
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="insurer_claim_no"
                            name="insurer_claim_no"
                            {...register("insurer_claim_no", {
                              required:
                                claimStatus === "In Progress" ||
                                  claimStatus === "Within Excess" ||
                                  claimStatus === "Withdrawn"
                                  ? false
                                  : "This is required.",
                            })}
                          />
                          {errors.insurer_claim_no && (
                            <ErrorLabel
                              message={errors.insurer_claim_no?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Contact Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_contact_name"
                            name="insurer_contact_name"
                            {...register("insurer_contact_name", {})}
                          />
                          {errors.insurer_contact_name && (
                            <ErrorLabel
                              message={errors.insurer_contact_name?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Contact
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            onKeyDown={(e) => {
                              const allowedKeys = [
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                                "Tab",
                              ];
                              if (
                                !/[0-9]/.test(e.key) &&
                                !allowedKeys.includes(e.key)
                              ) {
                                e.preventDefault();
                              }
                            }}
                            maxLength={10}
                            className="form-control"
                            id="insurer_contact"
                            name="insurer_contact"
                            {...register("insurer_contact", {
                              required: "Contact number is required.",
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Please enter a valid 10-digit mobile number.",
                              },
                            })}
                          />

                          {errors.insurer_contact && (
                            <ErrorLabel
                              message={errors.insurer_contact?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Contact Email
                            <span className="danger">*</span>
                          </label>
                          <input
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="insurer_contact_email"
                            name="insurer_contact_email"
                            {...register("insurer_contact_email", {
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Regex pattern for email validation
                                message: "Please enter a valid email address.",
                              },
                            })}
                          />
                          {errors.insurer_contact_email && (
                            <ErrorLabel
                              message={errors.insurer_contact_email?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Second Contact name
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_second_contact_name"
                            name="insurer_second_contact_name"
                            {...register("insurer_second_contact_name", {})}
                          />
                          {errors.insurer_second_contact_name && (
                            <ErrorLabel
                              message={
                                errors.insurer_second_contact_name?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Second Contact
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_second_contact"
                            name="insurer_second_contact"
                            {...register("insurer_second_contact", {
                              pattern: {
                                value: /^[0-9]{10}$/, // Validates a 10-digit numeric value
                                message:
                                  "Please enter a valid 10-digit mobile number.",
                              },
                            })}
                          />
                          {errors.insurer_second_contact && (
                            <ErrorLabel
                              message={errors.insurer_second_contact?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Second Contact Email
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_second_contact_email"
                            name="insurer_second_contact_email"
                            {...register("insurer_second_contact_email", {
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Regex pattern for email validation
                                message: "Please enter a valid email address.",
                              },
                            })}
                          />
                          {errors.insurer_second_contact_email && (
                            <ErrorLabel
                              message={
                                errors.insurer_second_contact_email?.message
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div class="form-group has-search">
                          <label for="follow_up_date" class="form-label">
                            Follow Up date
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="follow_up_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "follow_up_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",

                                  minDate: new Date(), // Set the maximum date to the current date
                                  enableTime: false,
                                }}
                              />
                            )}
                          // rules={{
                          //   required: "This is required.",
                          // }}
                          />
                          {errors.follow_up_date && (
                            <ErrorLabel
                              message={errors.follow_up_date?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Claim Handler Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="claim_handler_name"
                            name="claim_handler_name"
                            {...register("claim_handler_name", {})}
                          />
                          {errors.claim_handler_name && (
                            <ErrorLabel
                              message={errors.claim_handler_name?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Claim Handler Email
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="claim_handler_email"
                            name="claim_handler_email"
                            {...register("claim_handler_email", {
                              pattern: {
                                value:
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Regex pattern for email validation
                                message: "Please enter a valid email address.",
                              },
                            })}
                          />
                          {errors.claim_handler_email && (
                            <ErrorLabel
                              message={errors.claim_handler_email?.message}
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Claim Handler Branch
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="claim_handler_branch"
                            name="claim_handler_branch"
                            {...register("claim_handler_branch", {})}
                          />
                          {errors.claim_handler_branch && (
                            <ErrorLabel
                              message={errors.claim_handler_branch?.message}
                            />
                          )}
                        </div>
                      </div>
                      {
                        role === 'copsdashboard' && (
                          <div className="col-12 col-md-3 mb-3">
                            <div className="form-group">
                              <label className="label-control">
                                Claim Remark
                                <span className="danger">*</span>
                              </label>
                              <input
                                className="form-control"
                                id="cops_claim_remark"
                                name="cops_claim_remark"
                                {...register("cops_claim_remark", {})}
                              />
                              {errors.cops_claim_remark && (
                                <ErrorLabel
                                  message={errors.cops_claim_remark?.message}
                                />
                              )}
                            </div>
                          </div>
                        )

                      }

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group has-search">
                          <label for="claim_closed_date" class="form-label">
                            Claim Closed Date<span class="text-danger">*</span>
                          </label>
                          <span class="fa fa-calendar form-control-feedback"></span>
                          <Controller
                            name="claim_closed_date"
                            control={control}
                            render={({ field }) => (
                              <Flatpickr
                                {...field}
                                onChange={(value) => {
                                  var date = new Date(value).toISOString();
                                  setValue(
                                    "claim_closed_date",
                                    moment(date).format("DD-MM-YYYY")
                                  );
                                }}
                                id="disabled-picker"
                                className="form-control"
                                options={{
                                  dateFormat: "d-m-Y",

                                  minDate: new Date(), // Set the maximum date to the current date
                                  enableTime: false,
                                }}
                              />
                            )}
                            rules={{
                              required:
                                claimStatus === "Rejected" ||
                                  claimStatus === "Closed" ||
                                  claimStatus === "Settled" ||
                                  claimStatus === "Partially Settled"
                                  ? "This is required."
                                  : false,
                            }}
                          />
                          {errors.claim_closed_date && (
                            <ErrorLabel
                              message={errors.claim_closed_date?.message}
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Remark
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="remark"
                            name="remark"
                            placeholder="Enter remark"
                            {...register("remark", {})}
                          />
                          {errors.remark && (
                            <ErrorLabel message={errors.remark?.message} />
                          )}
                        </div>
                      </div>

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Control No
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="control_no"
                            name="control_no"
                            {...register("control_no", {})}
                          />
                          {errors.control_no && (
                            <ErrorLabel message={errors.control_no?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Contact Details
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="contact_details"
                            name="contact_details"
                            {...register("contact_details", {})}
                          />
                          {errors.contact_details && (
                            <ErrorLabel
                              message={errors.contact_details?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Name<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_name"
                            name="insurer_name"
                            placeholder="Select.."
                            {...register("insurer_name", {})}
                          />
                          {errors.insurer_name && (
                            <ErrorLabel
                              message={errors.insurer_name?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Saiba ID<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_saiba_id"
                            name="insurer_saiba_id"
                            placeholder="Select.."
                            {...register("insurer_saiba_id", {})}
                          />
                          {errors.insurer_saiba_id && (
                            <ErrorLabel
                              message={errors.insurer_saiba_id?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer ID<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_id"
                            name="insurer_id"
                            placeholder="Select.."
                            {...register("insurer_id", {})}
                          />
                          {errors.insurer_id && (
                            <ErrorLabel message={errors.insurer_id?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insurer Branch<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="insurer_branch"
                            name="insurer_branch"
                            placeholder="Select.."
                            {...register("insurer_branch", {})}
                          />
                          {errors.insurer_branch && (
                            <ErrorLabel
                              message={errors.insurer_branch?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            City&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="city"
                            name="city"
                            placeholder="Select.."
                            {...register("city", {})}
                          />
                          {errors.city && (
                            <ErrorLabel message={errors.city?.message} />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Department<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="department"
                            name="department"
                            placeholder="Select.."
                            {...register("department", {})}
                          />
                          {errors.department && (
                            <ErrorLabel message={errors.department?.message} />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Policy Type <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="policy_type"
                            name="policy_type"
                            placeholder="Select.."
                            {...register("policy_type", {})}
                          />
                          {errors.policy_type && (
                            <ErrorLabel message={errors.policy_type?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Customer Name&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="customer_name"
                            name="customer_name"
                            {...register("customer_name", {})}
                          />
                          {errors.customer_name && (
                            <ErrorLabel
                              message={errors.customer_name?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            User Saiba ID&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="user_saiba_id"
                            name="user_saiba_id"
                            {...register("user_saiba_id", {})}
                          />
                          {errors.user_saiba_id && (
                            <ErrorLabel
                              message={errors.user_saiba_id?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            User ID&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="user_id"
                            name="user_id"
                            {...register("user_id", {})}
                          />
                          {errors.user_id && (
                            <ErrorLabel message={errors.user_id?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            RM Name&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="rm_name"
                            name="rm_name"
                            {...register("rm_name", {})}
                          />
                          {errors.rm_name && (
                            <ErrorLabel message={errors.rm_name?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            CSC Name <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="csc_name"
                            name="csc_name"
                            {...register("csc_name", {})}
                          />
                          {errors.csc_name && (
                            <ErrorLabel message={errors.csc_name?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Vertical&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="vertical"
                            name="vertical"
                            value={"Corporate"}
                            placeholder="Select.."
                            {...register("vertical", {
                              required: "This is required.",
                            })}
                          />
                          {errors.vertical && (
                            <ErrorLabel message={errors.vertical?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Biz Type&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="biz_type"
                            name="biz_type"
                            placeholder="Select..."
                            {...register("biz_type", {
                              required: "This is required.",
                            })}
                          />
                          {errors.biz_type && (
                            <ErrorLabel message={errors.biz_type?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            TP Premium&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="tp_premium"
                            name="tp_premium"
                            placeholder="Select..."
                            {...register("tp_premium", {
                              required: "This is required.",
                            })}
                          />
                          {errors.tp_premium && (
                            <ErrorLabel message={errors.tp_premium?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Tp Broker Rate&nbsp;
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="tp_broker_rate"
                            name="tp_broker_rate"
                            placeholder="Select..."
                            {...register("tp_broker_rate", {
                              required: "This is required.",
                            })}
                          />
                          {errors.tp_broker_rate && (
                            <ErrorLabel
                              message={errors.tp_broker_rate?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Tp Broker Amount&nbsp;
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="tp_broker_amount"
                            name="tp_broker_amount"
                            placeholder="Select..."
                            {...register("tp_broker_amount", {
                              required: "This is required.",
                            })}
                          />
                          {errors.tp_broker_amount && (
                            <ErrorLabel
                              message={errors.tp_broker_amount?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Business Book Date&nbsp;
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="business_book_date"
                            name="business_book_date"
                            placeholder="Select..."
                            {...register("business_book_date", {
                              required: "This is required.",
                            })}
                          />
                          {errors.business_book_date && (
                            <ErrorLabel
                              message={errors.business_book_date?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Branch Name&nbsp;<span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="branch_name"
                            name="branch_name"
                            placeholder="Date.."
                            {...register("branch_name", {
                              required: "This is required.",
                            })}
                          />
                          {errors.branch_name && (
                            <ErrorLabel message={errors.branch_name?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Customer Group&nbsp;
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="customer_group"
                            name="customer_group"
                            placeholder="Date.."
                            {...register("customer_group", {
                              required: "This is required.",
                            })}
                          />
                          {errors.customer_group && (
                            <ErrorLabel
                              message={errors.customer_group?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Policy ID
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="policy_id"
                            name="policy_id"
                            {...register("policy_id", {})}
                          />
                          {errors.policy_id && (
                            <ErrorLabel message={errors.policy_id?.message} />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Type
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="type"
                            name="type"
                            {...register("type", {})}
                          />
                          {errors.type && (
                            <ErrorLabel message={errors.type?.message} />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            is_non_mandate_claim
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="is_non_mandate_claim"
                            name="is_non_mandate_claim"
                            {...register("is_non_mandate_claim", {})}
                          />
                          {errors.is_non_mandate_claim && (
                            <ErrorLabel
                              message={errors.is_non_mandate_claim?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Policy Type Auto ID
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="policy_type_auto_id"
                            name="policy_type_auto_id"
                            {...register("policy_type_auto_id", {})}
                          />
                          {errors.policy_type_auto_id && (
                            <ErrorLabel
                              message={errors.policy_type_auto_id?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Pinc Claim No
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="pinc_claim_no"
                            name="pinc_claim_no"
                            {...register("pinc_claim_no", {})}
                          />
                          {errors.pinc_claim_no && (
                            <ErrorLabel
                              message={errors.pinc_claim_no?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Pinc Claim Ref. No
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="pinc_claim_ref_no"
                            name="pinc_claim_ref_no"
                            {...register("pinc_claim_ref_no", {})}
                          />
                          {errors.pinc_claim_ref_no && (
                            <ErrorLabel
                              message={errors.pinc_claim_ref_no?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Branch_code
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="branch_code"
                            name="branch_code"
                            {...register("branch_code", {})}
                          />
                          {errors.branch_code && (
                            <ErrorLabel message={errors.branch_code?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Contact Person Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="contact_person_name"
                            name="contact_person_name"
                            {...register("contact_person_name", {})}
                          />
                          {errors.contact_person_name && (
                            <ErrorLabel
                              message={errors.contact_person_name?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Alternate Contact Person Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="alternate_contact_person_name"
                            name="alternate_contact_person_name"
                            {...register("alternate_contact_person_name", {})}
                          />
                          {errors.alternate_contact_person_name && (
                            <ErrorLabel
                              message={
                                errors.alternate_contact_person_name?.message
                              }
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Pinc Claim ID
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="pinc_claim_id"
                            name="pinc_claim_id"
                            {...register("pinc_claim_id", {})}
                          />
                          {errors.pinc_claim_id && (
                            <ErrorLabel
                              message={errors.pinc_claim_id?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insured Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="insured_name"
                            name="insured_name"
                            {...register("insured_name", {})}
                          />
                          {errors.insured_name && (
                            <ErrorLabel
                              message={errors.insured_name?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insured Name
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="insured_name"
                            name="insured_name"
                            {...register("insured_name", {})}
                          />
                          {errors.insured_name && (
                            <ErrorLabel
                              message={errors.insured_name?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insured Email
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="insured_email"
                            name="insured_email"
                            {...register("insured_email", {})}
                          />
                          {errors.insured_email && (
                            <ErrorLabel
                              message={errors.insured_email?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Insured Claim Ref No.
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="insured_claim_ref_no"
                            name="insured_claim_ref_no"
                            {...register("insured_claim_ref_no", {})}
                          />
                          {errors.insured_claim_ref_no && (
                            <ErrorLabel
                              message={errors.insured_claim_ref_no?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            SI Currency
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="si_currency"
                            name="si_currency"
                            {...register("si_currency", {})}
                          />
                          {errors.si_currency && (
                            <ErrorLabel message={errors.si_currency?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Follow Up Date
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="follow_up_date"
                            name="follow_up_date"
                            {...register("follow_up_date", {})}
                          />
                          {errors.follow_up_date && (
                            <ErrorLabel
                              message={errors.follow_up_date?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Product_details
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="claim_remark"
                            name="claim_remark"
                            {...register("claim_remark", {})}
                          />
                          {errors.claim_remark && (
                            <ErrorLabel
                              message={errors.claim_remark?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Claim Created At
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="claim_created_at"
                            name="claim_created_at"
                            {...register("claim_created_at", {})}
                          />
                          {errors.claim_created_at && (
                            <ErrorLabel
                              message={errors.claim_created_at?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Claim Updated At
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="claim_updated_at"
                            name="claim_updated_at"
                            {...register("claim_updated_at", {})}
                          />
                          {errors.claim_updated_at && (
                            <ErrorLabel
                              message={errors.claim_updated_at?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Created At
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="created_at"
                            name="created_at"
                            {...register("created_at", {})}
                          />
                          {errors.created_at && (
                            <ErrorLabel message={errors.created_at?.message} />
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Updated At
                            <span className="danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            id="updated_at"
                            name="updated_at"
                            {...register("updated_at", {})}
                          />
                          {errors.updated_at && (
                            <ErrorLabel message={errors.updated_at?.message} />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Vehicle No
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="vehicle_no"
                            name="vehicle_no"
                            placeholder="Date"
                            {...register("vehicle_no", {
                              required: "This is required.",
                            })}
                          />
                          {errors.vehicle_no && (
                            <ErrorLabel message={errors.vehicle_no?.message} />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Vehicle Make Model
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="vehicle_make_model"
                            name="vehicle_make_model"
                            placeholder="Date"
                            {...register("vehicle_make_model", {
                              required: "This is required.",
                            })}
                          />
                          {errors.vehicle_make_model && (
                            <ErrorLabel
                              message={errors.vehicle_make_model?.message}
                            />
                          )}
                        </div>
                      </div> */}

                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            Policy Due Date
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="policy_due_date"
                            name="policy_due_date"
                            placeholder="Date"
                            {...register("policy_due_date", {
                              required: "This is required.",
                            })}
                          />
                          {errors.policy_due_date && (
                            <ErrorLabel
                              message={errors.policy_due_date?.message}
                            />
                          )}
                        </div>
                      </div> */}
                      {/* <div className="col-12 col-md-3 mb-3">
                        <div className="form-group">
                          <label className="label-control">
                            dmsIds
                            <span className="danger">*</span>
                          </label>
                          <input
                            type="number"
                            onFocus={numberWheelChange}
                            className="form-control"
                            id="dmsIds"
                            name="dmsIds"
                            placeholder="Date"
                            {...register("dmsIds", {
                              required: "This is required.",
                            })}
                          />
                          {errors.dmsIds && (
                            <ErrorLabel message={errors.dmsIds?.message} />
                          )}
                        </div>
                      </div> */}
                      <>
                        <div className="col-12 mt-4">
                          <div
                            {...getRootProps2({ className: "dropzone" })}
                            className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                          >
                            <span className="badge bg-primary rounded p-2">
                              <input
                                accept=""
                                name="file"
                                {...getInputProps2()}
                              />
                              <i className="fa fa-plus" />
                            </span>{" "}
                            <span>Add Files</span>
                          </div>
                          <span
                            id="document_required"
                            className="d-none  text-danger fs-7 mx-auto "
                          >
                            {" "}
                            Document is required
                          </span>
                          {thumbs2}
                          {attachment2.length > 5 && (
                            <button
                              type="btn"
                              className="btn btn-primary rounded mt-4"
                              onClick={(e) => {
                                e.preventDefault();
                                removeAll2();
                              }}
                            >
                              Remove All
                            </button>
                          )}
                          {fileRejections2.length > 0 && (
                            <div className="mt-2">{fileRejectionItems2}</div>
                          )}

                        </div>
                        <div className="col-12 mt-1">
                          <div className="row">
                            {document && document.length > 0 ? (
                              document.map((objLink, index) => (
                                <div key={objLink.id || index} className="col-12 col-md-4 col-xl-3">
                                  <div className="card shadow bg-light rounded mb-1">
                                    <div className="card-body d-flex justify-content-between py-1">
                                      <a
                                        className="primary"
                                        onClick={async () => {
                                          try {
                                            const newWindow = window.open("", "_blank"); // open early
                                            const pdfres = await dispatch(actionDownload({ dmsIds: [objLink?.id] })).unwrap();
                                            const pdfUrl = pdfres?.data?.urls?.[0]?.url;

                                            if (pdfUrl) {
                                              newWindow.location.href = pdfUrl; // redirect the empty tab to PDF
                                            } else {
                                              newWindow.close(); // clean up if URL is not available
                                              alert("PDF link not available");
                                            }
                                          } catch (err) {
                                            alert("Failed to fetch PDF link");
                                          }
                                        }}

                                      >
                                        {objLink.actual_uploaded_file_name}
                                      </a>

                                      <span className="cursor-pointer">
                                        <i
                                          size={16}
                                          className="fa fa-trash btn btn-sm primary2"
                                          onClick={() => {
                                            Swal.fire({
                                              icon: "warning",
                                              text: "Are you sure, you want to delete this document?",
                                              cancelButtonText: "Cancel",
                                              showCancelButton: true,
                                            }).then(({ isConfirmed }) => {
                                              if (isConfirmed) {
                                                $("#progress-loader").removeClass("hidden");
                                                // Call delete action here
                                                // actionDeleteDocument({ claim_id: ..., dms_id: objLink.id });
                                              }
                                            });
                                          }}
                                        ></i>
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : null}

                          </div>
                        </div>
                      </>
                    </div>
                    <div className="form-actions border-0 float-none mt-1">
                      {
                        loading ?
                          <button
                            id="add_edit_claim"
                            className="btn btn-primary shadow round text-uppercase me-2"
                            type="submit"
                          >
                            <div className="d-flex align-items-center">
                              Submit
                              <span
                                id="add-edit-claim-loader"
                                className="spinner-border spinner-border-sm ml-half hidden"
                              ></span>
                            </div>
                          </button>
                          :
                          <button
                            id="add_edit_claim"
                            className="btn btn-primary shadow round text-uppercase me-2"
                            type="submit"
                          >
                            <div className="d-flex align-items-center">
                              Submit
                            </div>
                          </button>
                      }
                      <button
                        className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                        onClick={(event) => {
                          event.preventDefault();
                          navigate(-1)
                        }}
                      >
                        {" "}
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClaimForm;
